import { render, staticRenderFns } from "./RoomingReportFields.vue?vue&type=template&id=b684e710&"
import script from "./RoomingReportFields.vue?vue&type=script&lang=js&"
export * from "./RoomingReportFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports